// extracted by mini-css-extract-plugin
export default {"card":"UZ-z","carouselContainer":"VZ-z","carouselContent":"WZ-z"};